import { baseQueryWithReauth } from "@/store/baseQueryWithAuth";
import { createApi } from "@reduxjs/toolkit/query/react";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "Contacts",
    "Dashboard",
    "Me",
    "FolderItems",
    "Shares",
    "WellnessCheckins",
    "NextCheckin",
    "MonthlyAverage",
    "Cart",
    "Products",
    "GiftCards",
    "Orders",
    "ChatSessions",
    "ChatMessages",
    "DirectChatMessages",
    "TriggerResponse",
    "Graduation",
    "HygieneCheckins",
    "HygieneSettings",
    "HygieneStreak",
    "Attendance",
    "BeaconBundles",
    "BeaconLibrary",
    "BeaconNotes",
    "WellnessV2",
    "WellnessV2History",
    "WellnessV2Dashboard",
    "RightsItems",
    "RightsCategories",
  ],
  endpoints: () => ({}),
});
